import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

const LogoutCallbackPage = () => {
  useEffect(() => {
    location.href = '/logout.html';
  }, []);

  return <></>;
};

export const Route = createFileRoute('/logout/callback')({
  component: LogoutCallbackPage,
});
